// 9fbef606107a605d69c0edbcd8029e5d
import { call, takeLatest, put } from 'redux-saga/effects';
import logger from '@tcp/core/src/utils/loggerInstance';
import PAYMENT_CONSTANTS from '../Payment.constants';
import { getCardList, setDefaultPaymentSuccess, setDefaultPaymentError } from './Payment.actions';
import { getAddressList } from '../../AddressBook/container/AddressBook.actions';
import { setDefaultPaymentApi } from '../../../../../services/abstractors/account/DefaultPayment';
import { showError } from '../../../../common/molecules/GlobalErrorComponent/container/GlobalErrorComponent.actions';

export function* setDefaultPayment({ payload }) {
  try {
    const res = yield call(setDefaultPaymentApi, payload);
    if (res.body) {
      yield put(getCardList({ ignoreCache: true }));
      yield put(getAddressList({ ignoreCache: true }));
      yield put(setDefaultPaymentSuccess());
    } else {
      yield put(showError());
      yield put(setDefaultPaymentError());
    }
  } catch (err) {
    logger.error({
      error: err,
      extraData: {
        component: 'DefaultPayment - setDefaultPayment',
        payloadRecieved: payload,
      },
    });
    yield put(showError());
    yield put(setDefaultPaymentError(err));
  }
}

export function* DefaultPaymentSaga() {
  yield takeLatest(PAYMENT_CONSTANTS.SET_DEFAULT_PAYMENT, setDefaultPayment);
}

export default DefaultPaymentSaga;
